import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';
export const isIOS = () => /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
export const appInsightTrack = (businessID, loginUserID, report, objectParameter, Message) => {
    var objdata = {};
    objdata.Name = "LiveStreamACS";
    objdata.Bid = businessID;
    objdata.Userid = loginUserID;
    objdata.Description = Message;
    objdata.Fname = report;
    objdata.Parameters = JSON.stringify(
      objectParameter
    );
    appInsightTrackEvent(objdata);
  } 
const browserHistory = createBrowserHistory({ basename: '' });
const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
    config: {
        instrumentationKey: process.env.REACT_APP_INSTRUMENTATION_KEY,
        extensions: [reactPlugin],
        extensionConfig: {
          [reactPlugin.identifier]: { history: browserHistory }
        }
    }
});
appInsights.loadAppInsights();
const appInsightTrackEvent = (objdata) => {
  try {
      appInsights.trackEvent({
          name: objdata.Name,
          properties: {
              businessId: objdata.Bid,
              userid: objdata.Userid,              
              functionName: objdata.Fname,
              description: objdata.Description,
              parameters: objdata.Parameters
          }
      });
  } catch (e) {
  }
  
}
export { reactPlugin, appInsights, appInsightTrackEvent };